import {useEffect} from "react";
import database from "../database/database";
import isNull from "../mixin/isNull";
import route from "../enum/route";
import {useNavigate} from "react-router";
import useIdpRepository from "../repository/auth/useIdpRepository";
import {useSearchParams} from "react-router-dom";

/**
 * @rule-checker exclude
 * @returns {null}
 */
export default function () {
    const idpRepository = useIdpRepository();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        handleAuthCallback()
    }, []);

    const handleAuthCallback = async () => {
        const code = searchParams.get("code");

        if (!isNull(code)) {
            const res = await idpRepository.exchangeCode(code);

            if (res !== true) {
                return;
            }

            const userinfo = await idpRepository.userinfo();

            if (isNull(userinfo)) {
                window.location.replace(process.env.REACT_APP_AWS_AUTH_PAGE.replace("{clientId}", process.env.REACT_APP_AWS_CLIENT_ID).replace("{redirectUri}", process.env.REACT_APP_AWS_REDIRECT_URI));
                return;
            }

            database.write(database.TABLE_AUTHENTICATION, 'roles', userinfo.roles);
            database.write(database.TABLE_AUTHENTICATION, 'username', userinfo.preferred_username);
            database.write(database.TABLE_AUTHENTICATION, 'id', userinfo.attributes.external_id);
            database.write(database.TABLE_AUTHENTICATION, "attributes", userinfo.attributes);
            database.write(database.TABLE_AUTHENTICATION, 'roles', userinfo.roles);

            const redirectTo = database.read(database.TABLE_ROUTING, "after_auth");

            if (!isNull(redirectTo)) {
                console.info("User logged, redirect to " + redirectTo);
                database.write(database.TABLE_ROUTING, "after_auth", null);
                navigate(redirectTo);
                return;
            }
        }

        if (searchParams.get("test") == "true") {
            function sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            }


            localStorage.setItem("test", "true");

            await sleep(1000);

            const userinfo = await idpRepository.userinfo();

            if (isNull(userinfo)) {
                return;
            }

            database.write(database.TABLE_AUTHENTICATION, 'roles', userinfo.roles);
            database.write(database.TABLE_AUTHENTICATION, 'username', userinfo.preferred_username);
            database.write(database.TABLE_AUTHENTICATION, 'id', userinfo.attributes.external_id);
            database.write(database.TABLE_AUTHENTICATION, "attributes", userinfo.attributes);

            const redirectTo = database.read(database.TABLE_ROUTING, "after_auth");

            if (!isNull(redirectTo)) {
                console.info("User logged, redirect to " + redirectTo);
                database.write(database.TABLE_ROUTING, "after_auth", null);
                navigate(redirectTo);
                return;
            }
        }

        console.info("User logged, redirect to " + route.ENTREPRENEUR_INTERVENTIONS);
        navigate(route.ENTREPRENEUR_INTERVENTIONS);
    }

    return null;
}